import { apiClient } from './client';
import { API_ROUTES } from './routes';

const verificationService = {
  /**
   * Send OTP to user's phone number via WhatsApp
   * @returns {Promise<Object>} Response with success status and message
   */
  async sendOTP() {
    const response = await apiClient.post(API_ROUTES.VERIFICATION.SEND_OTP);
    return response?.data || null;
  },

  /**
   * Verify OTP code
   * @param {string} code - 6-digit OTP code
   * @returns {Promise<Object>} Response with success status and message
   */
  async verifyOTP(code) {
    const response = await apiClient.post(API_ROUTES.VERIFICATION.VERIFY_OTP, {
      code
    });
    return response?.data || null;
  },

  /**
   * Get current phone verification status
   * @returns {Promise<Object>} Object with phone_verified and phone_number
   */
  async getVerificationStatus() {
    const response = await apiClient.get(API_ROUTES.VERIFICATION.STATUS);
    return response?.data || null;
  }
};

export default verificationService;
